import axios from "axios";
import { axiosV3 } from "./axiosV3";
import { baseUrl } from "../../constants/constants";

export const _axios = axios.create({
  baseURL: `${baseUrl}/v2`,
  headers: {
    Authorization: `Bearer ${JSON.parse(
      localStorage.getItem("amoozeshMeliToken") || JSON.stringify("")
    )}`,
  },
});

_axios.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err?.response.status === 401) {
      if (Boolean(localStorage.getItem("amoozeshMeliToken")) === false) {
        localStorage.removeItem("amoozeshMeliToken");
        return;
      }

      console.log("Logging Out ....");

      try {
        localStorage.removeItem("amoozeshMeliToken");
        axiosV3.get("/user/logout");
      } catch (err) {
      } finally {
        window.location.reload();
      }
    }

    return Promise.reject(err);
  }
);

_axios.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err?.response.status === 401) {
      if (Boolean(localStorage.getItem("amoozeshMeliToken")) === false) {
        localStorage.removeItem("amoozeshMeliToken");
        return;
      }

      console.log("Logging Out ....");

      try {
        localStorage.removeItem("amoozeshMeliToken");
        axiosV3.get("/user/logout");
      } catch (err) {
      } finally {
        window.location.reload();
      }
    }

    return Promise.reject(err);
  }
);
